import { buildQueries, HTTP } from "@/api/http-common";
import ENDPOINT from "@/api/endpoints";

export function callApiLayDanhMucThongBao(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.THONG_BAO.GET_TAT_CA_DANH_MUC}?${buildQueries(payload)}`
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiLayNguonNhanThongBao(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.THONG_BAO.GET_TAT_CA_NGUON_NHAN_THONG_BAO}?${buildQueries(
        payload
      )}`
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiTaoThongBao(payload) {
  const config = { headers: { "Content-Type": "multipart/form-data" } };
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.THONG_BAO.TAO_THONG_BAO, payload, config)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiCapNhatThongBao(payload) {
  const config = { headers: { "Content-Type": "multipart/form-data" } };
  return new Promise((resolve, reject) => {
    return HTTP.put(ENDPOINT.THONG_BAO.CAP_NHAT_THONG_BAO, payload, config)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiGetChiTietThongBao(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.THONG_BAO.GET_CHI_TIET_THONG_BAO}?${buildQueries(payload)}`
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachQuanLyLoai(payload, endpoint) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${endpoint}?${buildQueries(payload)}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiTaoLoai(payload, endpoint) {
  return new Promise((resolve, reject) => {
    return HTTP.post(endpoint, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApisuaLoai(payload, endpoint) {
  return new Promise((resolve, reject) => {
    return HTTP.put(endpoint, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApixoaLoai(id, endpoint) {
  console.log(endpoint + id);
  return new Promise((resolve, reject) => {
    return HTTP.delete(endpoint + id)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachQuanLyNguon(payload, endpoint) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${endpoint}?${buildQueries(payload)}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiTaoNguon(payload, endpoint) {
  return new Promise((resolve, reject) => {
    return HTTP.post(endpoint, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApisuaNguon(payload, endpoint) {
  return new Promise((resolve, reject) => {
    return HTTP.put(endpoint, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApixoaNguon(id, endpoint) {
  console.log(endpoint + id);
  return new Promise((resolve, reject) => {
    return HTTP.delete(endpoint + id)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApilayDanhSachQuanLyThongBao(payload, endpoint) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${endpoint}?${buildQueries(payload)}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachThongBaoTheoDanhMucCoPaging(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.THONG_BAO.DANH_SACH_QUAN_LY_THONG_BAO}?${buildQueries(
        payload
      )}`
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiXoaThongBao(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.delete(ENDPOINT.THONG_BAO.XOA_THONG_BAO + "/" + payload.id)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiGetChiTietDanhMuc(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.THONG_BAO.GET_CHI_TIET_DANH_MUC}?${buildQueries(payload)}`
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiGuiDuyetThongBao(payload, endpoint) {
  return new Promise((resolve, reject) => {
    return HTTP.put(ENDPOINT.THONG_BAO.GUI_DUYET_THONG_BAO, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiDuyetThongBao(payload, endpoint) {
  return new Promise((resolve, reject) => {
    return HTTP.put(ENDPOINT.THONG_BAO.DUYET_THONG_BAO, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiTuChoiDuyetThongBao(payload, endpoint) {
  return new Promise((resolve, reject) => {
    return HTTP.put(ENDPOINT.THONG_BAO.TU_CHOI_DUYET_THONG_BAO, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiDangThongBao(payload, endpoint) {
  return new Promise((resolve, reject) => {
    return HTTP.put(ENDPOINT.THONG_BAO.DANG_THONG_BAO, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiDongMoThongBao(payload, endpoint) {
  return new Promise((resolve, reject) => {
    return HTTP.put(ENDPOINT.THONG_BAO.DONG_MO_THONG_BAO, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}
